import { render, staticRenderFns } from "./AtendimentoRealizado.vue?vue&type=template&id=5768604b"
import script from "./AtendimentoRealizado.vue?vue&type=script&lang=js"
export * from "./AtendimentoRealizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports